import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import type { TailwindColor } from '../super-latex.model';

@Component({
  selector: 'dojo-text-only-label-overlay',
  standalone: true,
  imports: [MarkdownModule, NgStyle],
  template: `
    <div class="label-container" [ngStyle]="labelStyles()">
      <markdown [data]="text()" [inline]="true" katex [katexOptions]="katexOptions()" />
    </div>
  `,
  styles: `
    :host {
      display: inline-block;
    }

    .label-container {
      font-size: 0.75rem;
      line-height: 1;
      white-space: nowrap;
      padding: 0 0.125rem;
      border-radius: 0.25rem;
      transform: translateY(-2px);
    }
  `,
})
export class TextOnlyLabelOverlayComponent {
  readonly text = input.required<string>();
  readonly color = input<TailwindColor>('sky');
  readonly offset = input<{ x?: number; y?: number }>();
  readonly katexOptions = input({
    throwOnError: false,
    strict: 'warn' as const,
    trust: true,
  });

  readonly labelStyles = computed(() => {
    const color = this.color();
    const offset = this.offset();
    const styles: Record<string, string> = {
      color: `var(--${color}-500)`,
      backgroundColor: 'var(--neutral-0)',
    };

    if (offset?.x || offset?.y) {
      styles['transform'] = `translate(${offset.x ?? 0}px, ${offset.y ?? 0}px)`;
    }

    return styles;
  });
}
